module.exports = __webpack_public_path__ + "static/media/26.99ff6ae0.png";